import React from 'react';
import { Container } from './styles';
import { Title, Icon, Button } from '@gerdau/hefesto';
import { cnpjMask, phoneMask } from '../../../../../../utils/formatStrings';
import { RewardBeneficiary } from '../index';
interface FormConfirmedProps {
  beneficiary: RewardBeneficiary;
  index: number;
  setDataConfirmed: () => void;
}
const FormConfirmed: React.FC<FormConfirmedProps> = ({
  beneficiary,
  index,
  setDataConfirmed
}) => {
  const getDisplayValue = (value: string | null) => {
    if (value === null) {
      return '';
    }
    value = value.replace(/\D/g, '');
    const displayValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(displayValue)) {
      return value;
    }
    const formatedDisplayValue = displayValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return formatedDisplayValue;
  };
  return (
    <Container>
      <div className="beneficiary-form">
        <div className="top-form">
          <div className="left-title">
            <Title level={3}>{'Beneficiário ' + index + ':'}</Title>
          </div>
          <div className="edit">
            <Button
              name="editar"
              icon={<Icon option="Edit" variant="primary" size="sm" />}
              iconPosition="right"
              variant="tertiary"
              onClick={() => {
                setDataConfirmed();
              }}
            >
              editar
            </Button>
          </div>
        </div>
        <div className="form-fields">
          <div className="field-line">
            <p>Razão social</p>
            <p>{beneficiary.companyName}</p>
          </div>
          <div className="field">
            <p>CNPJ</p>
            <p>
              {beneficiary.companyTaxVat
                ? cnpjMask(beneficiary.companyTaxVat)
                : ''}
            </p>
          </div>
          <div className="field">
            <p>Premiação referente a</p>
            <p>{beneficiary.rewardType}</p>
          </div>
          <div className="field-line">
            <p>Endereço para envio</p>
            <p>{beneficiary.address}</p>
          </div>
          <div className="field">
            <p>Telefone</p>
            <p>{beneficiary.phone ? phoneMask(beneficiary.phone) : ''}</p>
          </div>
          <div className="field">
            <p>Valor do cartão</p>
            <p>{getDisplayValue(beneficiary.rewardValue)}</p>
          </div>
        </div>
      </div>
      <div className="middle-line">
        <hr></hr>
      </div>
    </Container>
  );
};

export default FormConfirmed;
